var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showing)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__wrap"},[_c('div',{staticClass:"modal__content"},[_vm._t("content"),(_vm.loading)?_c('div',{staticClass:"modal__loading"},[_c('h4',{staticClass:"p-2 text-2xl"},[_vm._v(_vm._s(_vm.loadingMessage))]),_vm._m(0)]):_vm._e()],2)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"lds-dual-ring"})])
}]

export { render, staticRenderFns }